import createNotification from 'components/Settings/Utilities/CreateNotification';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { copyTextToClipboard } from 'components/Dashboard/helpers/copyFunctionality';

const getShareContentTypeSlug = (page) => {
  if (page === 'policy-asks' || page === 'policy-ask') {
    return 'policy-ask';
  }

  if (page === 'briefing-materials') {
    return 'briefing-material';
  }

  if (page === 'news-releases') {
    return 'news-release';
  }

  if (page === 'researches') {
    return 'research';
  }

  return page;
};

const useStakeholdersOnlyShareLink = ({ id, data, page, contentTypeSlug }) => {
  const { generalApiCall } = useGeneralApiCall();

  const createStakeholdersOnlyShareLink = async () => {
    const targetId = Number(id ?? data?.id);

    if (!targetId) {
      createNotification('danger', 'Could not create share link: missing content ID.');
      return;
    }

    const response = await generalApiCall({
      method: 'post',
      pathname: '/api/share-link',
      requestProperties: {
        targetContentUrlSlug: contentTypeSlug ?? getShareContentTypeSlug(page),
        targetId,
      },
      needsAuthentication: true,
      returnError: true,
      notShowErrorMessage: true,
    });

    if (!response || response?.status >= 400 || !response?.code) {
      const errorMessage =
        typeof response?.data === 'string'
          ? response.data
          : (response?.data?.message ?? 'Could not create share link.');
      createNotification('danger', errorMessage);
      return;
    }

    const shareUrl = `${import.meta.env.VITE_APP_POLICYINFLUENCE_APP_URL}/share/${response.code}`;
    copyTextToClipboard(shareUrl, 'Share link created and copied');
  };

  return { createStakeholdersOnlyShareLink };
};

export default useStakeholdersOnlyShareLink;
